import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";
import PartenairesView from "../views/PartenairesView.vue";
import ContactView from "../views/ContactView.vue";
import FormView from "../views/FormView.vue";
import StatusView from "../views/StatusView.vue";
import NotFoundView from "../views/NotFoundView.vue";
import ProduitsEligiblesView from "../views/ProduitsEligiblesView.vue";
import MentionsView from "../views/MentionsView.vue";
import WaitView from "../views/WaitView.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/produits-eligibles",
    name: "produits-eligibles",
    component: ProduitsEligiblesView,
  },
  {
    path: "/form",
    name: "form",
    component: FormView,
  },
  {
    path: "/status/:id/:uid",
    name: "status",
    component: StatusView,
  },
  {
    path: "/partenaires",
    name: "partenaires",
    component: PartenairesView,
  },
  {
    path: "/contact",
    name: "contact",
    component: ContactView,
  },
  {
    path: "/mentions-legales",
    name: "mentions-legales",
    component: MentionsView,
  },
  {
    path: "/wait",
    name: "wait",
    component: WaitView,
  },
  {
    path: "*",
    name: "not-found",
    component: NotFoundView,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

// Bloquer le site sur /wait si le domaine est odr-xiaomi-rn15

export default router;
